<template>

	<!-- Map -->
	<GmapMap ref="mapRef" :center="markers[0]" class="location-map" :zoom="12">
		<GmapMarker
		v-for="(m, index) in markers"
		:key="index"
		:position="m"
		/>
	</GmapMap>
</template>

<script>
export default {
	props: ['name', 'longitude', 'latitude'],
	data: function() {
		return {
			markers: [
				{
					lat: this.latitude,
					lng: this.longitude,
				}
			]
		}
	},
	mounted() {},
	computed: {},
	methods: {}
}
</script>
